<script>
  import ColorMixer from "./ColorMixer.svelte";
  import chroma from "chroma-js";
  let arrColorMixers = [];
  let count = 0;
  let colorMixed = "#999";
  let color1, color2, color3, color4;

  const mixColors = (e) => {
    let hexColor = e.detail.hexColor;
    let key = e.detail.key;

    if (key === 0) color1 = hexColor;
    else if (key === 1) color2 = hexColor;
    else if (key === 2) color3 = hexColor;
    else color4 = hexColor;

    switch (count) {
      case 2:
        colorMixed = chroma.mix(color1, color2).hex();
        break;
      case 3:
        colorMixed = chroma.mix(chroma.mix(color1, color2), color3).hex();
        break;
      case 4:
        colorMixed = chroma
          .mix(chroma.mix(color1, color2), chroma.mix(color3, color4))
          .hex();
        break;
      default:
        break;
    }
    // console.log(e.detail.hexColor, e.detail.key);
  };
</script>

<button
  class="edit-button"
  on:click={() => {
    if (count >= 4) return;
    arrColorMixers.push(1);
    arrColorMixers = [...arrColorMixers];
    count++;
  }}>Add Color Widget {count} of 4</button
>

{#if count > 0}
  <button
    class="edit-button"
    on:click={() => {
      arrColorMixers = [];
      count = 0;
    }}>Reset</button
  >
  <div class="color-mixers">
    <ul>
      {#each arrColorMixers as cm, index}
        <li>
          <ColorMixer
            key={index}
            hexColor={chroma.random().hex()}
            on:colorChanged={mixColors}
            dispatchOnInit
          />
        </li>
      {/each}
    </ul>
    {#if count > 1}
      <div id="color-preview">
        <div
          style="background-color: {colorMixed} ;box-shadow: {colorMixed} 3px 2px 3px 2px, {colorMixed} 0px 4px 6px -4px, {colorMixed} 3px 1px 3px inset;"
        />
        <span
          style=" border-top : 3px solid {colorMixed};
        border-bottom : 3px solid {colorMixed};"
        >
          {colorMixed}
        </span>
        <button
          class="edit-button"
          style=" border : 3px inset {colorMixed}; margin-top:3px;"
          on:click={() => {
            const cb = navigator.clipboard;
            cb.writeText(colorMixed).then(() => alert("Color copied"));
          }}>Copy Color</button
        >
      </div>
    {/if}
  </div>
{/if}

<style>
  #color-preview > span,
  #color-preview > button {
    display: block;
    width: 10%;
    text-align: center;
    font-size: 12px;
    color: #000;
    background-color: #fff;
    margin: auto;
  }
  #color-preview > div {
    width: 40%;
    height: 90px;
    margin: 0px auto;
    border-radius: 12px;
    /* border: 2px solid #000; */
  }
  ul {
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }

  .color-mixers {
    background-color: #fefefe;
    margin: 3% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 90%;
    border-radius: 12px;
  }
</style>
